export default __webpack_public_path__ + "static/media/icon.gloves.dadd65ec.svg";